import moment from 'moment-timezone';

// tzdata (2017a+) carries no alphabetic abbreviation for many zones, so moment's
// z/zz tokens and zoneAbbr() render a raw offset ("+04" for Asia/Dubai). Wrap
// zoneAbbr/zoneName once on the shared moment prototype so every format('z'/'zz')
// and zoneAbbr() call in hridaya shows the curated abbreviation instead; zones
// with a real abbreviation (IST, EST) and tz-less moments pass through unchanged.
// Imported for its side effect at the app entry (src/index.jsx). PROD-4698.
const IANA_TZ_ABBR: Record<string, string> = {
  'Asia/Dubai': 'GST',
  'Asia/Muscat': 'GST',
  'Asia/Qatar': 'AST',
  'Asia/Bahrain': 'AST',
  'Asia/Baghdad': 'AST',
  'Asia/Kuwait': 'AST',
  'Asia/Riyadh': 'AST',
  'Asia/Tehran': 'IRST',
  'Asia/Singapore': 'SGT',
  'Asia/Kuala_Lumpur': 'MYT',
  'Asia/Kuching': 'MYT',
  'Asia/Bangkok': 'ICT',
  'Asia/Ho_Chi_Minh': 'ICT',
  'Asia/Jakarta': 'WIB',
  'Asia/Manila': 'PHT'
};

type ZoneFn = (this: moment.Moment) => string;

const withOverride = (orig: ZoneFn): ZoneFn =>
  function (this: moment.Moment) {
    const abbr = orig.call(this);
    // The map wins for every zone it lists (all DST-free), so Asia/Manila — which
    // renders the misleading real string "PST" rather than a numeric offset — also
    // gets its curated "PHT". Unmapped zones keep their correct tzdata abbreviation.
    if (typeof this.tz === 'function') {
      const iana = this.tz();
      const override = iana && IANA_TZ_ABBR[iana];
      if (override) {
        return override;
      }
    }
    return abbr;
  };

const proto = moment.fn as unknown as { zoneAbbr: ZoneFn; zoneName: ZoneFn };
proto.zoneAbbr = withOverride(proto.zoneAbbr);
proto.zoneName = withOverride(proto.zoneName);

export {};
